/**
 * ninjaForm.js
 */

// Import
import "./ninjaForm.scss";
import $ from 'jquery';

$(document).ready(function() {

});

